import InputText, { InputTextProps as _InputTextProps } from './InputText';

export { InputText };
export type InputTextProps = _InputTextProps;
